<template>
    <ubi-page-container>
        <ubi-panel>
            <div v-for="info in produit">
                <el-row>
                    <el-col :span="24" class="text-justify"><h1>{{info.titre}}</h1></el-col>
                    <el-col :span="24" class="text-justify">
                        <div v-html="info.introduction"></div>
                    </el-col>
                    <el-col :span="24">
                        <img v-if="info.image != null" :src="require('@/assets/' + info.image)"
                             class="imageDetailsProduits" height="250" alt=""/>
                        <div class="text-center" v-else>
                            <ubi-icon class="no-photo" name="camera" size='350'/>
                        </div>
                    </el-col>
                    <el-col :span="24" class="text-justify">
                        <div v-html="info.descriptif"></div>
                    </el-col>
                </el-row>
                <!--            Block fonctionnalites-->
                <div class="fonctionnalitesProduits">
                    <ubi-card-container :data="fonctionnalites">
                        <template
                                v-slot="{
                      row: {
                          id,
                        titre,
                        descriptif,
                      }
                    }"
                        >
                            <ubi-card
                                    class="PostsList-item PostItem contenueFonctionnaliteDesciption"
                            >
                                <el-row class="blockIntroductionProduit">
                                    <el-col :span="24">
                                        <h3>{{ titre }}</h3>
                                    </el-col>
                                    <el-col :span="24" class="text-justify">
                                        <div>{{ descriptif }}</div>
                                    </el-col>
                                </el-row>
                            </ubi-card>
                        </template>
                    </ubi-card-container>
                </div>
                <el-row v-if="!isSubUser" class="blockEnSavoirPlusProduit">
                    <el-col :span="24"  class="text-center">
                        <h3>Vous souhaitez en savoir plus ?</h3>
                    </el-col>
                    <el-col :span="24">
                        <div class="text-center">
                            <el-button @click="sendMail(info.titre, info.image)" type="primary">Être contacté
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </ubi-panel>
    </ubi-page-container>
</template>

<script>
import { sendEmail } from '../../services/email'
import UbiPanel from '../../components/Panel'
import { mapGetters } from 'vuex'
import { HTTP_HYPER_ESPACE_BACKEND } from "@/services/http-common";

const axios = require('axios')

export default {
  name: 'DetailsProduit',
  components: { UbiPanel },
  data () {
    return {
      produit: [],
      fonctionnalitesRoute: [],
      fonctionnalites: []
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  mounted () {
    if (this.$route.params.idProduit) {
      this.chargerProduit(this.$route.params.idProduit)
    }
  },
  methods: {
    /**
             * On charge le produit
             **/
    async chargerProduit (idProduit) {
      return HTTP_HYPER_ESPACE_BACKEND
        .get('/produits/' + idProduit)
        .then(response => {
          this.produit.push({
            id: response.data.id,
            titre: response.data.titre,
            descriptif: response.data.descriptif,
            introduction: response.data.introduction,
            image: response.data.image,
            detail: response.data.detail
          })
          if (response.data.fonctionnalites.length != 0) {
            this.fonctionnalitesRoute = response.data.fonctionnalites
          }
          for (let i = 0; i < this.fonctionnalitesRoute.length; i++) {
            this.chargerFoncationnalite(this.fonctionnalitesRoute[i])
          }
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    async chargerFoncationnalite (idFonctionnalite) {
      return HTTP_HYPER_ESPACE_BACKEND
        .get(idFonctionnalite)
        .then(response => {
          this.fonctionnalites.push({
            id: response.data.id,
            titre: response.data.titre,
            descriptif: response.data.descriptif,
            introduction: response.data.introduction,
            image: response.data.image,
            detail: response.data.detail
          })
          return response.data
        })
        .catch(error => {
          return error
        })
    },
    /**
             * Envoi email pour info produit.
             */
    async sendMail (titre, image) {
      const libelle = 'produit_' + image.replace('.png', '')
      if (this.$ga) {
        this.$ga.event(libelle, 'clic', 'etre_recontacte', this.sitimmoUser.id)
      }
      const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
      const element = '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div> <p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: 17px;text-align: center;">L\'' + this.sitimmoUser.login + ' souhaite être recontacté pour en savoir plus sur le produit : ' + titre + '</p> </div>'
      const sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const mailData = {
        to: sendTo,
        subject: 'Demande d’information sur le produit : ' + titre + ' - ' + this.sitimmoUser.login,
        content: element.outerHTML
      }
      const repEnvoiMail = await sendEmail(mailData)
      if (repEnvoiMail.type === 'error') {
        this.erreurMessageEnvoye()
      } else {
        this.confirmationMessageEnvoye()
      }
    },
    erreurMessageEnvoye () {
      this.$message({
        showClose: true,
        message: this.$t('error.found'),
        type: 'error'
      })
    },
    confirmationMessageEnvoye () {
      this.$message({
        showClose: true,
        message: 'Votre demande a bien été envoyée. Notre équipe va revenir vers vous dans les meilleurs délais.',
        type: 'success'
      })
    }

  }
}
</script>

<style>
    .imageDetailsProduits {
        margin-top: 20px;
        margin-bottom: 20px;
        display: block;
        margin-left: auto;
        margin-right: auto
    }

    .fonctionnalitesProduits {
        margin-top: 30px;
    }

    .blockEnSavoirPlusProduit {
        margin: auto;
        width: 50%;
        margin-top: 35px;
    }

    .contenueFonctionnaliteDesciption{
        height: 180px;
    }
</style>
